// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	useEmulators: false,
	firebase: {
		apiKey: "AIzaSyBbFleicIiJBi9dsMEqkpuVIceMuqfuqRI",
		// authDomain: "cesta-urbana-test.firebaseapp.com",
		// databaseURL: "https://cesta-urbana-test-default-rtdb.europe-west1.firebasedatabase.app",
		projectId: "cesta-urbana-test",
		// storageBucket: "cesta-urbana-test.appspot.com",
		messagingSenderId: "495186462466",
		appId: "1:495186462466:web:db0bb4c4439297bd55a41b",
		measurementId: "G-44W58C8JQJ"
	},
	hj: '3608475',
	serviceConnection: 'mysql',
	apiUrl: 'https://beta.admin.cestaurbana.com/api/v1',
	apiBaseUrl: 'https://beta.admin.cestaurbana.com',
};



// apiKey: "AIzaSyDczESgknwrXp0xNPHJXIBxooUoZTXE9MY",
// authDomain: "delpuestoacasa-test.firebaseapp.com",
// databaseURL: "https://delpuestoacasa-test-default-rtdb.europe-west1.firebasedatabase.app",
// projectId: "delpuestoacasa-test",
// storageBucket: "delpuestoacasa-test.appspot.com",
// messagingSenderId: "352387406684",
// appId: "1:352387406684:web:9667aa234eab08b90e3f99",
// measurementId: "G-NNRYN2YKBD"

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
